import styled from 'styled-components';

import {
  PurchaseAmount as DefaultPurchaseAmount,
  Reward as DefaultReward,
  Rewards as DefaultRewards,
  TransactionDate as DefaultTransactionDate,
} from './transaction.styled.default';

export * from './transaction.styled.default';

export const Rewards = styled(DefaultRewards)`
  align-items: center;
`;

export const Reward = styled(DefaultReward)`
  text-align: center;
  color: ${Styles.color.primary};
  font-weight: ${Styles.fontWeight.heavy};
  font-family: ${Styles.fontFamily.body};
`;

export const PurchaseAmount = styled(DefaultPurchaseAmount)`
  font-weight: ${Styles.fontWeight.heavy};
`;

export const TransactionDate = styled(DefaultTransactionDate)`
  font-weight: ${Styles.fontWeight.heavy};
`;
